module.exports = __webpack_public_path__ + "img/perguntasFrequentes.a2c12b34.svg";